// @flow
import { Schema } from "../../../components/form";

const formSchema = new Schema({
  email: {
    type: "string",
    required: true,
    validator: value => {
      function validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      }

      if (!validateEmail(value)) {
        return "E-mail inválido";
      }
    }
  },
  password: {
    type: "string",
    required: true
  }
});

export default formSchema;
